import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  UnstyledLink,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React, {FC} from 'react';
import sc, {css} from 'styled-components';
import {Countries} from '../LanguageCountrySwitch';
import {CountryFlag} from './CountryFlag';

export const CountriesList: FC<{className?: string; countries: Countries}> = ({
  className,
  countries,
}) => {
  return (
    <Wrapper className={className}>
      {countries.map(({flagSrc, isSelected, label, linkTarget}) => {
        const key = `languageCountrySwitchCountry-${label}`;

        return (
          <Country
            $active={isSelected}
            data-testid={key}
            key={key}
            openExternalLinkInNewTab={false}
            to={linkTarget!}
            aria-label={undefined}
          >
            <Flag src={flagSrc} />
            <Label data-testid={`languageCountrySwitchCountryLabel`}>
              {label}
            </Label>
            {isSelected && <Checkmark asset={GenericIconName.Checkmark} />}
          </Country>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = sc.div`
  background-color: ${COLORS.White};
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Flag = sc(CountryFlag)`
  margin-right: 0.5rem;
`;

const Label = sc.span`
  color: ${COLORS.Black};
  font-size: ${FONT_SIZES.px14};
  margin-bottom: 1px;
`;

const Country = sc(UnstyledLink)<{$active: boolean}>`
  align-items: center;
  background: ${COLORS.White};
  border: none;
  border-top: 1px solid ${COLORS.Grey3};
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  height: 3.5rem;
  line-height: 1;
  padding: 0 1rem;
  transition: background 0.3s ease;
  width: 100%;

  &:focus-visible {
    background: ${COLORS['Outline.Grey']};
    outline: none;
  }

  @media (hover: hover) {
    &:hover {
      background: ${COLORS.Grey5};
    }
  }

  ${({$active}) =>
    $active &&
    css`
      ${Label} {
        font-weight: ${FONT_WEIGHTS.bold};
      }
    `}

  &:focus-visible {
    outline-offset: -2px;
  }
`;

const Checkmark = linariaStyled(Icon)`
  color: ${COLORS.Black};
  height: 1.25rem;
  margin-left: auto;
  width: 1.25rem;
`;
